<template>
  <v-card class="mb-4">
    <v-card-title class="d-flex align-center justify-space-between">
      <span>
        <v-icon class="mr-2" color="blue">mdi-sim</v-icon>
        {{ t.dashboard?.sims_stats || 'SIMs Statistics' }}
      </span>
      <v-btn
        icon
        size="small"
        variant="text"
        :loading="rebuilding"
        @click="rebuildStats"
        :title="t.dashboard?.recalculate_stats || 'Recalculate statistics'"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-progress-circular v-if="loading" indeterminate size="24" class="mr-2" />

      <v-row v-else>
        <v-col cols="6" md="2">
          <v-card variant="tonal" color="success" class="text-center pa-3">
            <div class="text-h4">{{ stats.active || 0 }}</div>
            <div class="text-caption">{{ t.dashboard?.active || 'Active' }}</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="2">
          <v-card variant="tonal" color="info" class="text-center pa-3">
            <div class="text-h4">{{ stats.not_provisioned || 0 }}</div>
            <div class="text-caption">{{ t.dashboard?.not_provisioned || 'Not provisioned' }}</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="2">
          <v-card variant="tonal" color="warning" class="text-center pa-3">
            <div class="text-h4">{{ stats.pending || 0 }}</div>
            <div class="text-caption">{{ t.dashboard?.pending || 'Pending' }}</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="2">
          <v-card variant="tonal" color="orange" class="text-center pa-3">
            <div class="text-h4">{{ stats.suspended || 0 }}</div>
            <div class="text-caption">{{ t.dashboard?.suspended || 'Suspended' }}</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="2">
          <v-card variant="tonal" color="grey" class="text-center pa-3">
            <div class="text-h4">{{ stats.terminated || 0 }}</div>
            <div class="text-caption">{{ t.dashboard?.terminated || 'Terminated' }}</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="2">
          <v-card variant="tonal" color="primary" class="text-center pa-3">
            <div class="text-h4">{{ stats.total || 0 }}</div>
            <div class="text-caption">{{ t.dashboard?.total || 'Total' }}</div>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'
import { getSimsStats } from '@/composables/useGetSimsAPI'
import { rebuildClientStatistics } from '@/composables/useDisplaySettingsAPI'
import store from '@/store'

export default {
  name: 'SimsStatsSection',
  props: {
    config: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      stats: {},
      loading: true,
      rebuilding: false
    }
  },
  computed: {
    t() { return tRef.value },
    token() {
      return store.getters.getToken
    }
  },
  async mounted() {
    await this.loadStats()
  },
  methods: {
    async loadStats() {
      this.loading = true
      try {
        const result = await getSimsStats(this.token)
        if (!result.error) {
          this.stats = result.stats || {}
        }
      } finally {
        this.loading = false
      }
    },
    async rebuildStats() {
      this.rebuilding = true
      try {
        await rebuildClientStatistics(this.token)
        // Wait a moment for background rebuild to complete, then reload
        setTimeout(() => this.loadStats(), 2000)
      } finally {
        this.rebuilding = false
      }
    }
  }
}
</script>
